import { Box } from '@mui/material';
import Wizard from '../Wizard/Wizard';

export default function Outro() {
    return (
        <Box bgcolor="#C7D5C8" borderRadius={5} padding={3}>
            <Box margin="auto" maxWidth={700}>
                <Wizard highlight />
            </Box>
        </Box>
    );
}
